import { createSlice } from '@reduxjs/toolkit';

// Replaces the Email-Marketing `useAppStore` zustand store. Holds the
// cross-page refresh signal that pages watch to know when to refetch.

const initialState = {
  lastRefresh: null,
};

const emailAppSlice = createSlice({
  name: 'emailApp',
  initialState,
  reducers: {
    setRefreshed: (state) => {
      state.lastRefresh = Date.now();
    },
  },
});

export const { setRefreshed } = emailAppSlice.actions;

export default emailAppSlice.reducer;
